import {getPagecluster} from "@otto-ec/global-resources/misc";

const PAGE_IMPRESSION_FEATURES_ATTRIBUTE = "data-tr-v1-tr-page-impression.features";
const CLICK_ACTION_ATTRIBUTE = "data-tr-v1-click.action";
const CLICK_ATTRIBUTE = "data-tr-v1-click";
const DATA_FEATURE_ORDER_ATTRIBUTE = "data-feature-order";
const DATA_FEATURE_TRACKING_LABELS_ATTRIBUTE = "data-feature-tracking-labels";

export function enhanceTracking(containerElement: Element, targetElement: Element, attributionFeaturePrefix: string): void {
    const parentElement = containerElement.closest(`[${DATA_FEATURE_ORDER_ATTRIBUTE}]`);
    if (parentElement) {
        const featureOrder = Number(parentElement.getAttribute(DATA_FEATURE_ORDER_ATTRIBUTE));
        const featureTrackingLabels = JSON.parse(parentElement.getAttribute(DATA_FEATURE_TRACKING_LABELS_ATTRIBUTE) || "{}");
        const wkLabels = {'wk.promo_AttributionFeature': [`${attributionFeaturePrefix}_${getPagecluster()}`]};
        enhancePageImpressionFeaturesAttribute(targetElement, featureOrder, featureTrackingLabels);
        enhanceClickActionAttribute(targetElement, featureOrder, featureTrackingLabels);
        enhanceClickAttribute(targetElement, wkLabels);
    }
}

export function enhancePageImpressionFeaturesAttribute(targetElement: Element, featureOrder: number, featureTrackingLabels: {[key: string]: string[]}): void {
    const pageImpressionFeaturesAttribute = targetElement.getAttribute(PAGE_IMPRESSION_FEATURES_ATTRIBUTE);
    if (pageImpressionFeaturesAttribute) {
        const pageImpressionFeatures = JSON.parse(pageImpressionFeaturesAttribute);
        if (featureOrder) {
            pageImpressionFeatures[0].position = featureOrder;
        }
        if (Object.keys(featureTrackingLabels).length > 0) {
            pageImpressionFeatures[0].labels = {...featureTrackingLabels, ...pageImpressionFeatures[0].labels};
        }
        targetElement.setAttribute(PAGE_IMPRESSION_FEATURES_ATTRIBUTE, JSON.stringify(pageImpressionFeatures));
    }
}

export function enhanceClickActionAttribute(targetElement: Element, featureOrder: number, featureTrackingLabels: {[key: string]: string[]}): void {
    const clickActionAttribute = targetElement.getAttribute(CLICK_ACTION_ATTRIBUTE);
    if (clickActionAttribute) {
        const clickAction = JSON.parse(clickActionAttribute);
        if (featureOrder) {
            clickAction.features[0].position = featureOrder;
        }
        if (Object.keys(featureTrackingLabels).length > 0) {
            clickAction.features[0].labels = {...featureTrackingLabels, ...clickAction.features[0].labels};
        }
        targetElement.setAttribute(CLICK_ACTION_ATTRIBUTE, JSON.stringify(clickAction));
    }
}

export function enhanceClickAttribute(targetElement: Element, wkLabels: {[key: string]: string[]}): void {
    const clickAttribute = targetElement.getAttribute(CLICK_ATTRIBUTE);
    if (clickAttribute) {
        let click = JSON.parse(clickAttribute);
        if (Object.values(wkLabels).length > 0) {
            click = {...click, ...wkLabels};
        }
        targetElement.setAttribute(CLICK_ATTRIBUTE, JSON.stringify(click));
    }
}